// 📂 src/backend/firebase/schema/settings/tasa-schema.ts
import z from 'zod';

export const Currencies = z.enum(['USD', 'EUR', 'BS', 'COP', 'PEN', 'MXN', 'ARS', 'CLP', 'UYU']);

export type CurrenciesType = z.infer<typeof Currencies>;

export const TasaSchema = z.object({
  // Tasa Oficial BCV (USD -> BS)
  currentTasa: z.number(),

  // Tasa Peso Colombiano (USD -> COP)
  copTasa: z.number().default(4000),

  // Tasa Global (EUR -> USD) - Necesaria para salones que usen el Euro como base
  eurToUsd: z.number().default(1.08),

  // Tasa Derivada (EUR -> BS) - Calculada automáticamente: currentTasa * eurToUsd
  eurToBs: z.number().optional(),

  tasaLastUpdated: z.string(), // ISO String para trazabilidad
});

export type Tasa = z.infer<typeof TasaSchema>;
